import * as z from "zod/v4";

const updateBrandSummaryInput = z.object({ summary: z.string().max(4000) });

const updateBrandSummaryOutput = z.object({ success: z.boolean() });

export const updateBrandSummary: {
  name: "updateBrandSummary";
  input: typeof updateBrandSummaryInput;
  output: typeof updateBrandSummaryOutput;
} = {
  name: "updateBrandSummary" as const,
  input: updateBrandSummaryInput,
  output: updateBrandSummaryOutput,
};
